import React from 'react';
import { Link } from 'react-router-dom';
import { StageBadge } from './StageBadge';
import { useLeads } from '../contexts/LeadsContext';
import { formatAmount, type Lead } from '../data/mockData';
const accentByKey: Record<Lead['accent'], string> = {
  blue: 'bg-brand',
  teal: 'bg-teal',
  purple: 'bg-navy',
  green: 'bg-success'
};
type QueueCardProps = {
  onSelect: (lead: Lead) => void;
};
export function QueueCard({
  onSelect
}: QueueCardProps) {
  const {
    leads
  } = useLeads();
  const queue = leads;
  return <section className="rounded-xl border border-gray-200 bg-white" aria-labelledby="queue-heading" data-id="element-176" data-mp="3qigt5f3j8d8u">
      <div className="flex items-center gap-3 border-b border-gray-200 px-5 py-3.5" data-id="element-177" data-mp="3uhfyh0t6ec0t">
        <h2 id="queue-heading" className="text-[14px] font-semibold text-ink" data-id="element-178" data-mp="354pg2c68wmg">
          Needs you now
        </h2>
        <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-semibold text-gray-600" data-id="element-179" data-mp="32rktxwwqyfrk">
          {queue.length}
        </span>
        <p className="hidden text-[12px] text-gray-500 sm:block" data-id="element-180" data-mp="15rjwjeuulbmm">
          new leads · follow-ups due today · new apps
        </p>
        <Link to="/leads" className="ml-auto text-[12.5px] font-medium text-brand hover:text-brand-dark" data-id="element-181" data-mp="10trxm0vscp8x">
          Open full queue
        </Link>
      </div>
      <ul className="divide-y divide-gray-100" data-id="element-182" data-mp="r3p2nv53t17y">
        {queue.map(lead => <li key={lead.id} data-id="element-183" data-mp="m4c5ohkiqdrn">
            <button type="button" onClick={() => onSelect(lead)} className="flex w-full items-center gap-3 px-5 py-3.5 text-left transition-colors hover:bg-gray-50 focus:outline-none focus-visible:bg-gray-50" data-id="element-184" data-mp="m4lxmap4iuzz">
              <span className={['h-9 w-[3px] shrink-0 rounded-full', accentByKey[lead.accent]].join(' ')} aria-hidden="true" data-id="element-185" data-mp="84b8bc3gpogx" />
              <span className="min-w-0 flex-1" data-id="element-186" data-mp="22j40t291tz4n">
                <span className="block truncate text-[13.5px] text-ink" data-id="element-187" data-mp="22g9h5cxv0ica">
                  <span className="font-semibold" data-id="element-188" data-mp="rlo1zos0orv">{lead.name}</span>
                  <span className="text-gray-500" data-id="element-189" data-mp="5kokqgouoeca">
                    {' '}
                    · {lead.state} · {formatAmount(lead.amount)}
                  </span>
                </span>
                <span className="mt-0.5 block truncate text-[12.5px] text-gray-500" data-id="element-190" data-mp="3ryeov2fnqlvv">
                  {lead.detail}
                </span>
              </span>
              <StageBadge stage={lead.stage} data-id="element-191" data-mp="jhjwigwhkjw1" />
            </button>
          </li>)}
      </ul>
    </section>;
}